export function canUseTestCheckout(userId: string | undefined, configuredUserId: string | undefined): boolean {
  return Boolean(userId && configuredUserId && userId === configuredUserId)
}
